import axios from 'axios'

export default {
    get(npi, fields) {
        const _fields = (fields || ['firstName', 'middleName', 'lastName', 'email', 'phone']).join(',')

        return axios.get(`unauthenticated/provider-database/${npi}`, { params: { _fields } })
    },
}
